// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"877eb3a3","453":"c954134c"}[chunkId] + ".chunk.js";
};